import { useLazyQuery } from '@apollo/client';
import { TRANSLATE_ARTICLE } from 'src/services/graphql/translate/query';
import { useAlert } from './useAlert';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  setIsTranslated,
  setOpenPopupTranslate,
  setResultTranslationData
} from 'src/features/translateArticle';

export interface TranslateArticleResponse {
  translation_translateArticle: {
    title: string;
    content: string;
  };
}

export interface TranslateArticlePayload {
  title: string;
  content: string;
  language?: string;
}

export const useTranslateArticle = () => {
  const { handleClickAlert } = useAlert();
  const dispatch = useAppDispatch();
  const { isTranslated } = useAppSelector(
    (state) => state.storeTranslateArticle
  );

  const [translateArticle, resTranslateArticle] = useLazyQuery<
    TranslateArticleResponse,
    TranslateArticlePayload
  >(TRANSLATE_ARTICLE, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      if (!res) {
        handleClickAlert({
          message: 'Failed to translate text, please try again later.',
          severity: 'error',
          horizontal: 'center',
          vertical: 'top'
        });
        return;
      }
      dispatch(setOpenPopupTranslate(false));
      dispatch(setIsTranslated(true));
      dispatch(setResultTranslationData(res));
      handleClickAlert({
        message: 'Text has successfully translated',
        severity: 'success',
        horizontal: 'center',
        vertical: 'top'
      });
    },
    onError: () => {
      handleClickAlert({
        message: 'Failed to translate text, please try again later.',
        severity: 'error',
        horizontal: 'center',
        vertical: 'top'
      });
    }
  });

  const handleClickTranslateButton = (text: TranslateArticlePayload) => {
    translateArticle({
      variables: {
        ...text,
        content: text.content.trim()
      }
    });
  };

  return {
    translateArticle,
    resTranslateArticle,
    isTranslated,
    handleClickTranslateButton
  };
};
